import React, { createContext, useContext } from 'react'
import axios from 'axios'
import { useAuthContext } from './AuthContext'
import { toast } from 'react-toastify'
const Context = createContext()

const RequestContext = ({ children }) => {
  const { user, logout } = useAuthContext()

  const axiosInstance = axios.create({
    baseURL: 'https://itbani.ir/api/v1'
  })
  const Request = async ({ data, url, method }) => {
    const options = {
      method: method || 'post',
      url,
      headers: {
        Accept: 'application/json',
        authorization: 'Bearer ' + user?.token
      },
      data: data
    }
    return await axiosInstance(options).then((response) => {
      return response
    }).catch((e) => {
      const { response: { status, data } } = e;
      if (status === 401) {
        logout();
        return;
      }
      toast.error(data)
      return { status: status, statusText: data || 'اتصال به اینترنت را بررسی کنید !' }
    })
  }

  return (
    <Context.Provider value={{ Request }}>{children}</Context.Provider>
  )
}

export const useRequest = () => useContext(Context)

export default RequestContext
